import isObject from 'lodash/isObject';
import some from 'lodash/some';

export function hasItemInArray<I>(arr: I[], item: I): boolean {
  if (isObject(item)) {
    return some(arr, item);
  }
  return some(arr, si => si === item);
}
